import React, { useEffect } from 'react';
import { connect, useDispatch } from "react-redux";

import ModalCTA from '../modal/ModalCTA';
import ModalButton from '../modal/ModalButton';

import { setModal, setRequestError } from "../../../actions/index";
import { setUidAutomix, setCurrentIdAutomix } from "../automix/redux/actions/index";

// Error App Management
function ConnectedErrorWrapper({ error, storeAuth, storeRoute, setModal }) {
  const dispatch = useDispatch();
  useEffect(() => {
    if (error && error.message) {
      // console.log(error)
      let message = (error.message) ?  error.message : `Request Failed.`;
      const isExpired = message.includes(`401`);
      // message = (isExpired) ? `Your session has expired or you have multiple open sessions, please sign in.` : message
      message = (message.includes(`403`)) ? `Unfortunately, this track is not licensed for streaming in your country.` : message
      message = (message.includes(`404`)) ? `Sorry, but we couldn't find what you wanted.` : message
      let title = (isExpired) ? `Session Timeout` : error.message;
      title = (title.includes(`403`)) ? 'Territory restricted' : title;
      let label = (isExpired) ? `Log In` : `Close`;
      const onClick = () => { 
        if (title === 'Territory restricted') {
          const el = document.querySelector('#ref-prev.active');
          if (el) {
            window.history.back();
          } else {
            storeRoute.goTo('/home');
          }
        }
        dispatch(setRequestError(null))
      };
      if (isExpired) {
        console.log('Error Wapprer - ', message)
        window['YouDJ'].automix_off();
        dispatch(setUidAutomix(null));
        dispatch(setCurrentIdAutomix(null));
        dispatch(setRequestError(null))

        // TODO - SAVE BDD TO SEE WHERE IS THE PROBLEM

        storeAuth.logout();
        window.location.reload(); // PROVISOIRE
      } else {

        window['YouDJ'].automix_off();
        dispatch(setUidAutomix(null));
        dispatch(setCurrentIdAutomix(null));

        setModal({
          content: (
            <ModalCTA
              title={title}
              description={message}
              styleContainer={{marginTop: `-50%`, marginLeft: `-10%`}}
              styleBody={{gap: 26}}
              autoCancel={false}
            >
              <ModalButton label={label} className={`primary`} onClick={onClick} />
            </ModalCTA>
          ),
          enableHeader: false,
          active: true,
          underlayBackground: `rgba(36, 36, 36, 0.8)`
        });
      }
    }
  }, [error, storeAuth, storeRoute, setModal, dispatch])
  return null;
}

const ErrorWrapper = connect(
  state => ({
    error: state.error,
    storeAuth: state.storeAuth,
    storeRoute: state.storeRoute
  }),
  dispatch => ({
    setModal: content => dispatch(setModal(content))
  })
)(ConnectedErrorWrapper);

export default ErrorWrapper;
